export const environment = {
  production: true,
  baseUrl: 'https://api.cadaa.com.sa/',
  defaultLang: 'ar',
  xAuthKey: 'tyl6RaZTsolxdo7ddizQDLaXvCBNcj6TJjIkrFuq6eysuEMyXlHk3cjL0vkG7BsG',
  environment: 'production',
  firebase: {
    apiKey: 'AIzaSyDMU0nr-4pM1PH7_7UapWdFJkVGHZUrl5M',
    authDomain: 'invest-01---production.firebaseapp.com',
    projectId: 'invest-01---production',
    storageBucket: 'invest-01---production.firebasestorage.app',
    messagingSenderId: '601913388971',
    appId: '1:601913388971:web:8d3cb0236b8ff781f2acee',
    measurementId: 'G-R5Y4EWDDDG',
  },
};
